import Link from 'next/link';
import { memo } from 'react';

import { VisuallyHidden } from '@air/primitive-visually-hidden';

import { AirLogo } from '~/components/v2/components/shared/branding/AirLogo';
import { Routes } from '~/constants/routes';

export const AssetModalHeaderAirLogoLink = memo(() => {
  return (
    <Link data-testid="PUBLIC_VIEWER_AIR_LOGO" href={Routes.marketing.root} rel="noopener noreferrer" target="_blank">
      <VisuallyHidden>Visit Air's website</VisuallyHidden>
      <AirLogo className="h-3 text-black dark:text-white" />
    </Link>
  );
});

AssetModalHeaderAirLogoLink.displayName = 'AssetModalHeaderAirLogoLink';
